import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';

import { FilesAndSuggestionsPluginService } from './filesandsuggestions-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { InformationComponent } from '../../modal/information.component';
import { Inspection } from '../../shared/models';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'fileandsuggestion-upload',
    templateUrl: './fileandsuggestion-upload.component.html',
    standalone: false
})
export class FilesAndSuggestionUploadPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  images: string[] = [];
  loaded = false;
  files: any[] = [];
  takedPhotos: any[] = [];
  public plugin: any;
  public inspection: Inspection;
  public assets: any = [];
  allImages: any[] = [];
  editForm: UntypedFormGroup;
  errorMsg = '';
  public processing = false;
  private mediaStreamTrack: any;
  public isTorchPossible: boolean;
  public isFlashOn: boolean;
  public cameras: any;
  public currentCamera: any;
  public isFrontCamera: boolean;
  public isCameraOn = false;
  @ViewChild('errorMessage', { static: true }) errorMessage: InformationComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: FilesAndSuggestionsPluginService,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
    this.editForm = new UntypedFormGroup({});
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.stopStream(this.stream);
    const inputFile = new FormData();

    for (let i = 0; i < this.files.length; i++) {
      inputFile.append('files[' + i + ']', this.files[i], this.files[i].name);
      const angle = this.allImages.find((img) => img.type === 'file' && img.index === i).angle;
      inputFile.append(`fileAngles[${i}]`, angle);
    }

    for (let i = 0; i < this.takedPhotos.length; i++) {
      inputFile.append('images', this.takedPhotos[i]);
      const angle = this.allImages.find((img) => img.type === 'camera' && img.index === i).angle;
      inputFile.append(`imageAngles[${i}]`, angle);
    }

    this.processing = true;
    this.service
      .addFiles(this.inspectionId, this.pointId, this.pluginId, inputFile, [...this.files, ...this.takedPhotos])
      .subscribe((data) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.stopStream(this.stream);
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
    this.editForm = new UntypedFormGroup({});
    this.initDevices();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.inspection = data.inspection;
      this.assets = this.plugin.config.Assets;
    });
  }

  initDevices() {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      this.cameras = devices.filter((device) => device.kind === 'videoinput');
      if (this.cameras.length > 1) {
        this.currentCamera = this.cameras[0];
        this.isFrontCamera = true;
      }
    });
  }

  handleInputChange(e: any) {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.files.push(file);
      const pattern = /^image\/(png|jpg|jpeg)$/;
      const reader = new FileReader();

      if (!file.type.match(pattern)) {
        this.errorMessage.open();
        return;
      }

      this.loaded = false;

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsDataURL(file);
    }
  }

  clearInput(e: any) {
    e.target.value = null;
  }

  public video: any;
  public stream: any;

  handleReaderLoaded(e: any) {
    const reader = e.target;
    const data = reader.result;
    this.images.push(data);
    this.allImages.unshift({ angle: 0, index: this.images.length - 1, type: 'file', data: data });
    this.loaded = true;
  }

  deleteAsset(assetId: string) {
    this.service.deleteFile(this.inspectionId, this.pointId, this.pluginId, assetId).subscribe((data) => {
      this.goToBack();
    });
  }

  stopStream(stream: any) {
    if (stream) {
      stream.getVideoTracks().forEach((track: any) => {
        track.stop();
      });
    }
  }

  // take photo from webcam
  public hasGetUserMedia() {
    const n = <any>navigator;
    return !!(n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);
  }

  // to define
  public width = 350;
  public height = 0;
  public streaming = false;

  public turnOnCamera() {
    this.isCameraOn = true;
    const canvas: any = document.querySelector('#canvas');

    if (this.hasGetUserMedia()) {
      const n = <any>navigator;
      const getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia).bind(n);

      if (getUserMedia) {
        let constraint = {};
        if (this.currentCamera) {
          constraint = {
            video: {
              deviceId: this.currentCamera.deviceId
            },
            audio: false
          };
        } else {
          constraint = {
            video: true,
            audio: false
          };
        }
        getUserMedia(
          constraint,
          (stream) => {
            this.stream = stream;
            this.video.srcObject = stream;
            this.video.play();
            this.mediaStreamTrack = stream.getVideoTracks()[0];
            setTimeout(() => {
              const capabilities = this.mediaStreamTrack.getCapabilities();
              this.isTorchPossible = capabilities.torch;
              this.cdf.detectChanges();
            }, 600);
          },
          (err) => {
            this.errorMsg = 'An error occured!';
            // console.log("An error occured! " + err);
          }
        );
      } else {
        this.errorMsg = 'no support for media';
        // alert("no support for media");
      }

      const self = this;
      self.video = document.querySelector('#video');

      self.video.addEventListener(
        'canplay',
        (ev: any) => {
          if (!self.streaming) {
            self.height = self.video.videoHeight / (self.video.videoWidth / self.width);

            self.video.setAttribute('width', self.width);
            self.video.setAttribute('height', self.height);
            canvas.setAttribute('width', self.width);
            canvas.setAttribute('height', self.height);
            self.streaming = true;
          }
        },
        false
      );
    }

    this.cdf.detectChanges();
  }

  closeCamera() {
    this.isCameraOn = false;
    this.streaming = false;
    this.stopStream(this.stream);
  }

  public takePicture() {
    const self = this;
    const canvas: any = document.querySelector('#canvas');

    if (self.width && self.height) {
      if (this.isTorchPossible && this.isFlashOn) {
        this.mediaStreamTrack.applyConstraints({ advanced: [{ torch: true }] });
        setTimeout(() => {
          this.drawPicture(canvas);
          this.mediaStreamTrack.stop();
          this.turnOnCamera();
        }, 300);
      } else {
        this.drawPicture(canvas);
      }
    }
  }

  private drawPicture(canvas: any) {
    const self = this;
    const context = canvas.getContext('2d');
    canvas.width = self.width;
    canvas.height = self.height;
    context.drawImage(this.video, 0, 0, self.width, self.height);
    const data = canvas.toDataURL('image/png');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.restore();
    self.takedPhotos.push(data);
    this.allImages.unshift({ angle: 0, index: self.takedPhotos.length - 1, type: 'camera', data: data });
    this.cdf.detectChanges();
  }

  public changeFlash() {
    if (this.isTorchPossible) {
      this.isFlashOn = !this.isFlashOn;
    }
  }

  public switchCamera() {
    if (this.currentCamera) {
      if (this.isFrontCamera) {
        this.currentCamera = this.cameras[1];
        this.isFrontCamera = false;
      } else {
        this.currentCamera = this.cameras[0];
        this.isFrontCamera = true;
      }

      this.mediaStreamTrack.stop();
      this.turnOnCamera();
    }
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service
      .deleteFilesPlugin(this.inspectionId, this.pointId, this.pluginId, this.plugin.config.Assets)
      .subscribe((success: boolean) => {
        if (success) {
          this.goToBack();
        }
      });
  }

  rotateItem(item: any, i: number) {
    if (item.angle && item.angle === 270) {
      item.angle = 0;
    } else {
      item.angle += 90;
    }
  }

  removeTakedPhoto(index: number) {
    this.takedPhotos.splice(index, 1);
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.images.splice(index, 1);
  }

  removeItem(type: string, index: number, i: number) {
    if (type === 'camera') {
      this.removeTakedPhoto(index);
    } else if (type === 'file') {
      this.removeFile(index);
    }
    this.allImages.splice(i, 1);
    this.allImages.forEach((el) => {
      if (el.type === type && el.index > index) {
        el.index = el.index - 1;
      }
    });
  }
}
